import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
import { PROFESSIONAL_POSITION_CANDIDATES } from '../../../../../../define/consts/profile';
import { REQUEST_DIVISION_CANDIDATE_PRO } from '../../../../../../define/consts/registration';
import { propStr, propOneOf } from '../../../../../../helpers/custom-prop-types';
import { slideSearchRegistrationValidate } from '../../../../../../validate/custom/slide_search/registration';
import Select2Fields from '../../../../Common/Fields/Select2Fields';
import PlainInputComponent from '../../../../Common/PlainInputComponent';
/**
 * 役職部分を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchFormPositionField = (props) => {
    const { form, userMode } = props;
    const selector = formValueSelector(form);
    const position = useSelector((state) => selector(state, 'position')) || {};
    const requestDivision = useSelector((state) => selector(state, 'requestDivision'));
    // コンサルか
    const isProfessional = userMode === 'professional';
    // ゲストかつ所属組織：コンサルファームを選んだか
    const isGuestSelectedProfessional = userMode === 'guest' &&
        typeof requestDivision === 'string' &&
        parseInt(requestDivision, 10) === REQUEST_DIVISION_CANDIDATE_PRO.value;
    const select2Components = useMemo(() => ({
        IndicatorSeparator: () => null,
    }), []);
    // コンサル、もしくはゲストで所属組織：コンサルを選択した場合にのみ、役職を表示する
    if (!(isProfessional || isGuestSelectedProfessional)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'position_row' }, { children: [_jsx("div", Object.assign({ className: 'row_title' }, { children: "\u5F79\u8077" })), _jsx(Select2Fields, { blurInputOnSelect: false, candidateValues: PROFESSIONAL_POSITION_CANDIDATES, classNamePrefix: 'position_select', components: select2Components, isMulti: false, isSearchable: false, menuPosition: 'fixed', name: 'position', placeholder: '役職を選択してください', validate: slideSearchRegistrationValidate.position })] })), position.other && (_jsx("div", Object.assign({ className: 'position_other_row' }, { children: _jsx(Field, { className: 'form_input input-form-text', component: PlainInputComponent, name: 'positionOther', placeholder: '役職（その他）の内容を入力してください', validate: slideSearchRegistrationValidate.positionOther }) })))] }));
};
SlideSearchFormPositionField.propTypes = {
    form: propStr().isRequired,
    userMode: propOneOf(['guest', 'client', 'free_professional', 'professional'])
        .isRequired,
};
export default SlideSearchFormPositionField;
